import { useMutation } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const usePayRentSession = () => {
  const mutation = useMutation({
    mutationFn: async (data: {
      sessionId: string | number;
      cardId?: string | number;
    }) => {
      const paymentWindow = window.open('/payment/loader', '_blank');
      const res = await API.paySession(data.sessionId, data.cardId);
      const url = res.data.data.payment_url;
      const id = res.data.data.id;

      if (paymentWindow) paymentWindow.location.href = url;

      return { paymentWindow, url, id };
    },
    onError: () => {
      if (paymentWindow) paymentWindow.close();
    },
  });
  return {
    pay: mutation.mutate,
    data: mutation.data,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};
